module.exports = __webpack_public_path__ + "static/media/snoopyhot01.d2cc6889.jpg";